module.exports = __webpack_public_path__ + "img/slide.92902a0a.jpg";